/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Sticky } from "../../basic/sticky";
import { Header } from "../header";
import { HeaderSearch } from "../header-search";
import { CtaWrapper, LogoWrapper, SecondaryMenu, DefaultMenu, Login, Monogram } from "../header-helper-components";
import { Sidebar } from "../sidebar";
import { accessCheck } from "../../../../isomorphic/utils";
import { DOUBLE_LAYER_ROOT_MARGIN } from "../../../constants";

import "./header-three.m.css";
import { MobileDownloadLinks } from "../../atoms/mobile-apps";

export const HeaderThree = props => {
  const isSearchFormVisible = get(props, ["header", "isSearchFormVisible"]);
  const showAppDownloadLinks = get(props.enableAppDownloadLinks) === true ? "show-app-download-links" : "";
  const enableAppDownloadLinks =
    get(props.enableAppDownloadLinks) === true ? "app-download-links-enabled" : "secondary-menu";
  const isSSOEnabled = accessCheck(props.enableSSO) ? "shift-logo" : "";

  return (
    <Sticky rootMargin={DOUBLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="layer-1">
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon-mobile" />
          </div>
          <div styleName="cta">
            <CtaWrapper {...props} />
          </div>

          <div styleName={`logo ${isSSOEnabled}`}>
            <LogoWrapper {...props} />
          </div>
          <div styleName={`${enableAppDownloadLinks}`}>
            <SecondaryMenu {...props} customCssClasses={("header-three-secondary", `${showAppDownloadLinks}`)} />
          </div>
          {props.enableAppDownloadLinks && (
            <div styleName="download-links">
              <MobileDownloadLinks {...props} />
            </div>
          )}
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon-mobile" />
          </div>
          {accessCheck(props.enableSSO) && (
            <div styleName="login">
              <Login {...props} />
            </div>
          )}
        </div>
        <div styleName={`layer-2 ${isSearchFormVisible ? "show-search-form" : ""}`}>
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" />
          </div>
          <div styleName="monogram">
            <Monogram {...props} />
          </div>
          <div styleName="default-menu">
            <DefaultMenu {...props} />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};

HeaderThree.propTypes = {
  header: PropTypes.shape({
    isSearchFormVisible: PropTypes.bool
  }),
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool,
  enableAppDownloadLinks: PropTypes.bool
};

const HeaderTemplate = ({ showHeaderRowOnly = false }) => (
  <Header renderTemplate={HeaderThree} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
